import { useEffect } from 'react';
import { useControl } from 'react-map-gl/mapbox';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

export type GeofenceDrawControlProps = {
    onReady: (draw: MapboxDraw | null) => void;
    onChange: () => void;
};

/**
 * Wraps a Mapbox GL Draw instance as a react-map-gl control. Exposes the draw
 * instance via `onReady` and notifies `onChange` on create/update/delete so the
 * parent can read the current polygon.
 */
export function GeofenceDrawControl(props: GeofenceDrawControlProps): null {
    const { onReady, onChange } = props;

    const draw = useControl<MapboxDraw>(
        () =>
            new MapboxDraw({
                displayControlsDefault: false,
                defaultMode: 'simple_select'
            }),
        ({ map }) => {
            map.on('draw.create', onChange);
            map.on('draw.update', onChange);
            map.on('draw.delete', onChange);
        },
        ({ map }) => {
            map.off('draw.create', onChange);
            map.off('draw.update', onChange);
            map.off('draw.delete', onChange);
        }
    );

    useEffect(() => {
        onReady(draw);
        return () => onReady(null);
    }, [draw, onReady]);

    return null;
}
